import React, { useState } from "react";
import i18n from "i18n";

import { isMobile } from "helpers/Mobile";

import InputText from "components/MainApp/atoms/Forms/MainInput";
import TagReadInput from "shared/components/Input/TagReadInput";

import DeviceSelector from "components/Functionals/DeviceSelector";

import styles from "./ReadingPanel.module.scss";

const ReadingPanel = ({
  enabledRead,
  typeRead,
  refRead,
  receiveEvent,

  handleSearch,
  handleClear,

  total,
  read,
}) => {
  const [searchedValue, setsearchedValue] = useState("");

  const searchValue = (e) => {
    setsearchedValue(e.target.value.trim());
  };

  const handleSubmit = function (e) {
    e.preventDefault();
    handleSearch(searchedValue);
    setsearchedValue("");
  };

  const toggle = (
    <DeviceSelector 
      enabled={enabledRead} 
      typeRead={typeRead} 
      refRead={refRead} 
      receiveEvent={receiveEvent} 
      includeType={"MOB_READER"}
    />
  );
  return (
    <div className={styles["reading-panel-outer"]}>
      {isMobile && toggle}
      <div className={styles["reading-panel-container"]}>
        <div className={styles["reading-panel-top"]}>
          {!isMobile && toggle}
        </div>
        <div className={styles["reading-panel-bottom"]}>
          <div className={styles["reading-panel-left"]}>
             <TagReadInput searchValue={searchValue} searchedValue={searchedValue} handleSubmit={handleSubmit} />
          </div>
          <div className={styles["reading-panel-center"]}>
            <p className={styles["reading-panel-count"]}>
              <span>{read}</span> / {total}
            </p>
          </div>
          <div className={styles["reading-panel-right"]}>
            <button className={styles["reading-panel-reset"]} onClick={handleClear}>{i18n.t("clean")}</button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ReadingPanel;
